import { Flex, Radio } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RangePickerValue, WeeklyDateRangePicker } from 'components/DateRange';
import WidgetCard from 'components/WidgetCard';

import type { CheckboxOptionType } from 'antd/es/checkbox';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from 'routes/AllRoutes';
import useTrackerWrapper from 'hooks/useTracker';

interface SeasonSummaryWidgetLayoutProps {
  children: React.ReactNode;
  dateRange?: RangePickerValue;
  onDateRangeChange?: (date: RangePickerValue) => void;
}

const TaskManagementLayout = ({
  children,
  dateRange,
  onDateRangeChange,
}: SeasonSummaryWidgetLayoutProps) => {
  const { t } = useTranslation();
  const { onClickWrapper } = useTrackerWrapper();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const options: CheckboxOptionType<string>[] = useMemo(
    () => [
      {
        label: t('taskManagement.labels.taskView'),
        value: routes.taskManagement,
      },
      {
        label: t('taskManagement.labels.agronomistView'),
        value: routes.taskAgronomistView,
      },
    ],
    [t],
  );

  const handleTabChange = (tab: string) => {
    const selectedOption = options?.find((opt) => opt.value === tab);
    onClickWrapper(selectedOption?.label?.toString() ?? '', () =>
      navigate({ pathname: tab, search }),
    );
  };

  return (
    <WidgetCard
      renderHeader={() => (
        <WeeklyDateRangePicker
          value={dateRange}
          onChange={onDateRangeChange}
          rootStyle={{ marginTop: -4 }}
        />
      )}
      headerExtraContent={
        <Radio.Group
          options={options}
          onChange={(e) => {
            handleTabChange?.(e.target.value);
          }}
          value={pathname}
          optionType="button"
          style={{ marginBlock: 8 }}
        />
      }
    >
      <Flex vertical gap={32} className="mt-3">
        {children}
      </Flex>
    </WidgetCard>
  );
};

export default TaskManagementLayout;
